/**
 * Normalize partner/entity status values across demo seeds (Actif) and SQLite (active).
 */

export function normalizeRecordStatus(status) {
  if (status == null || status === '') return status;
  const normalized = String(status).trim().toLowerCase();
  if (normalized === 'actif' || normalized === 'active' || normalized === 'disponible' || normalized === 'available') {
    return 'active';
  }
  if (normalized === 'inactif' || normalized === 'inactive' || normalized === 'indisponible' || normalized === 'unavailable') {
    return 'inactive';
  }
  return status;
}

export function isActiveRecordStatus(status) {
  return normalizeRecordStatus(status) === 'active';
}

export function isActiveRecord(record) {
  if (!record || typeof record !== 'object') return false;
  if (record.active === true || record.active === 1) return true;
  return isActiveRecordStatus(record.status);
}
